<template>
  <div>
    <div class="row pt-3 l-m-b-20 align-items-center">
      <div class="d-flex align-items-center title-search col-9">
        <h1 class="w-75">Company payment gateways</h1>
        <div class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control search-input" type="text" v-model="q" @keyup="searchText($event)"
                 placeholder="Search"
          />
        </div>
      </div>
      <div class="col-3 text-right">
        <button class="btn btn-primary mb-2" type="button" @click="showCreateModal = true"
                v-if="$_can('companies.payment-profiles.store')"
        >
          ADD PAYMENT GATEWAY
        </button>
      </div>
      <div class="col-12 row mobile-hidden">
        <div class="col-12 d-flex align-items-center filters-field">
          <span class="pr-2">Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.carrier.length && carriers">
              <span v-for="carrier in filters.carrier" :key="carrier" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('carrier', carrier)" />
                Carrier: {{ carriers.find(el => el.id === carrier).name }}</span>
            </span>
            <span v-if="filters.company.length && companies">
              <span v-for="company in filters.company" :key="company" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('company', company)" />
                Company: {{ companies.find(el => el.id === company).name }}</span>
            </span>
            <span v-if="filters.gateway && paymentGateways && paymentGateways.length > 0" class="filter-item btn btn-filter mr-1">
              <span class="mod-icon-filter" @click="removeFilter('gateway')" />
              Gateway: {{ paymentGateways.find(el => el.id === filters.gateway).name }}</span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
      </div>
    </div>
    <template v-if="!paymentProfilesAuthorize && !paymentProfilesStripe">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12">
          <label>Authorize.NET</label>
        </div>
      </div>

      <table class="table m-table table-hover">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th>Name</th>
            <th>Client key</th>
            <th>Login ID</th>
            <th>Transaction key</th>
            <th>Companies</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="paymentProfile in paymentProfilesAuthorize"
              :key="paymentProfile.id"
              @click="$_can('companies.payment-profiles.show') && openEditModal(paymentProfile)"
              class="pointer"
          >
            <td>{{ paymentProfile.id }}</td>
            <td>{{ paymentProfile.name }}</td>
            <td>{{ paymentProfile.credentials.clientKey }}</td>
            <td>{{ paymentProfile.credentials.apiLoginID }}</td>
            <td>{{ paymentProfile.credentials.transactionKey }}</td>
            <!--          <td>{{paymentProfile.companies.map((el) => { return el.name }).join(',')}}</td>-->
            <td><span v-dompurify-html="paymentCompanies(paymentProfile.companies)" class="payment-companies" /></td>
          </tr>
          <tr v-if="paymentProfilesAuthorize && !paymentProfilesAuthorize.length">
            <td colspan="6" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <pagination :change-page="changePageAuthorize" :meta="metaAuthorize" />

      <div class="row">
        <div class="col-12">
          <label>Stripe</label>
        </div>
      </div>

      <table class="table m-table table-hover">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th>Name</th>
            <th>Secret key</th>
            <th>Publishable key</th>
            <th>Companies</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="paymentProfile in paymentProfilesStripe"
              :key="paymentProfile.id"
              @click="$_can('companies.payment-profiles.show') && openEditModal(paymentProfile)"
              class="pointer"
          >
            <td>{{ paymentProfile.id }}</td>
            <td>{{ paymentProfile.name }}</td>
            <td>{{ paymentProfile.credentials.apiKey }}</td>
            <td>{{ paymentProfile.credentials.publicKey }}</td>
            <td><span v-dompurify-html="paymentCompanies(paymentProfile.companies)" class="payment-companies" /></td>
          </tr>
          <tr v-if="paymentProfilesStripe && !paymentProfilesStripe.length">
            <td colspan="5" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <pagination :change-page="changePageStripe" :meta="metaStripe" />
    </template>

    <!--Create-->
    <modal v-if="showCreateModal" @close="closeModal" size="modal-large" body="l-modal-body-full-height">
      <div slot="header">
        <h1>Add new gateway</h1>
      </div>
      <div slot="body">
        <template>
          <div class="row">
            <div class="col-12">
              <div class="select-wrap mb-2">
                <label class="m-label">Payment processor</label>
                <simple-select v-model="paymentProfile.payment_gateway_id"
                               :options="paymentGateways"
                               :input-id="'payment-processor-select'"
                               placeholder="Select Payment Processor"
                               @input="errors.clear('payment_gateway_id')"
                />
              </div>
              <error-field :errors="errors" field="payment_gateway_id" />
            </div>
            <div class="col-12">
              <div class="select-wrap mb-2">
                <label class="m-label">Name</label>
                <input type="text" class="form-control"
                       v-model="paymentProfile.name"
                       @input="errors.clear('name')"
                />
              </div>
              <error-field :errors="errors" field="name" />
              <div class="select-wrap mb-2">
                <label>Companies</label>
                <multiselect v-model="paymentProfile.companies"
                             v-if="companies"
                             :options="companies"
                             :multiple="true"
                             :clear-on-select="false"
                             :hide-selected="true"
                             :preserve-search="false"
                             label="name"
                             track-by="id"
                >
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span>{{ props.option.name }}</span>
                      <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                    </span>
                  </template>
                </multiselect>
              </div>
              <error-field :errors="errors" field="companies" />
              <div v-show="paymentProfile.payment_gateway_id === 1">
                <label class="m-label">Credentials</label>
                <div class="select-wrap mb-2">
                  <label class="m-label">Secret key</label>
                  <input type="text" class="form-control" name="apiKey"
                         v-model="paymentProfile.credentials.apiKey"
                         @input="errors.clear('credentials')"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Publishable key</label>
                  <input type="text" class="form-control" name="publicKey"
                         v-model="paymentProfile.credentials.publicKey"
                         @input="errors.clear('credentials')"
                  />
                </div>
              </div>
              <div v-show="paymentProfile.payment_gateway_id === 2">
                <label class="m-label">Credentials</label>
                <div class="select-wrap mb-2">
                  <label class="m-label">Client key</label>
                  <input type="text" class="form-control" name="clientKey"
                         v-model="paymentProfile.credentials.clientKey"
                         @input="errors.clear('credentials')"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Login ID</label>
                  <input type="text" class="form-control" name="apiLoginID"
                         v-model="paymentProfile.credentials.apiLoginID"
                         @input="errors.clear('credentials')"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Transaction key</label>
                  <input type="text" class="form-control" name="transactionKey"
                         v-model="paymentProfile.credentials.transactionKey"
                         @input="errors.clear('credentials')"
                  />
                </div>
              </div>
              <error-field :errors="errors" field="credentials" />
            </div>
          </div>
          <div class="row m-0">
            <div class="col-12">
              <button type="button" class="btn btn-primary pull-right ld-ext-right"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
                      @click="save"
              >
                Add
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer" />
    </modal>

    <!-- Edit Payment gateway -->
    <modal v-if="showEditModal" @close="closeModal" size="modal-large" body="l-modal-body-full-height">
      <div slot="header">
        <h4>Edit gateway</h4>
      </div>
      <div slot="body">
        <template>
          <div class="row">
            <div class="col-12">
              <div class="select-wrap mb-2">
                <label class="m-label">Payment processor</label>
                <p class="px-3 stripe-logo">{{ editProfile.payment_gateway_name }}</p>
              </div>
              <error-field :errors="errors" field="payment_gateway_id" />
            </div>
            <div class="col-12">
              <div class="select-wrap mb-2">
                <label class="m-label">Name</label>
                <input type="text" class="form-control"
                       v-model="editProfile.name"
                       @input="errors.clear('name')"
                />
              </div>
              <error-field :errors="errors" field="name" />
              <div class="select-wrap mb-2">
                <label>Companies</label>
                <multiselect v-model="editProfile.companies"
                             v-if="companies"
                             :options="companies"
                             :multiple="true"
                             :clear-on-select="false"
                             :hide-selected="true"
                             :preserve-search="false"
                             label="name"
                             track-by="id"
                >
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span>{{ props.option.name }}</span>
                      <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                    </span>
                  </template>
                </multiselect>
              </div>
              <error-field :errors="errors" field="companies" />
              <label class="m-label">Credentials</label>
              <div v-show="editProfile.payment_gateway_id === 1">
                <div class="select-wrap mb-2">
                  <label class="m-label">Secret key</label>
                  <input type="text" class="form-control" name="apiKey"
                         v-model="editProfile.credentials.apiKey"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Publishable key</label>
                  <input type="text" class="form-control" name="publicKey"
                         v-model="editProfile.credentials.publicKey"
                  />
                </div>
              </div>
              <div v-show="editProfile.payment_gateway_id === 2">
                <div class="select-wrap mb-2">
                  <label class="m-label">Client key</label>
                  <input type="text" class="form-control" name="clientKey"
                         v-model="editProfile.credentials.clientKey"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Login ID</label>
                  <input type="text" class="form-control" name="apiLoginID"
                         v-model="editProfile.credentials.apiLoginID"
                  />
                </div>
                <div class="select-wrap mb-2">
                  <label class="m-label">Transaction key</label>
                  <input type="text" class="form-control" name="transactionKey"
                         v-model="editProfile.credentials.transactionKey"
                  />
                </div>
              </div>
              <error-field :errors="errors" field="credentials" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right">
              <button type="button" class="btn btn-secondary" @click="deleteProfile">
                Delete
              </button>
              <button type="button" class="btn btn-primary ld-ext-right"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
                      @click="edit"
              >
                Save
                <div class="ld ld-ball ld-flip" />
              </button>
              <error-field :errors="errors" field="payment_profile" />
            </div>
          </div>
        </template>
      </div>
      <div slot="footer">
        <error-field :errors="errors" field="company_id" />
      </div>
    </modal>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column justify-content-between">
          <div class="filters-container">
            <div @click="showFilters = !showFilters" class="pointer">
              <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
            </div>
            <div>
              <p>
                Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
              </p>
            </div>
            <div class="l-bg-white">
              <div class="row">
                <div class="col">
                  <div class="row filters">
                    <div class="col-12" v-if="companies && companies.length">
                      <div class="select-wrap">
                        <label>Company</label>
                        <key-multiselect v-model="filters.company"
                                         :options="companies"
                                         :multiple="true"
                                         :clear-on-select="false"
                                         :close-on-select="false"
                                         :hide-selected="true"
                                         :id="'company-select'"
                                         :placeholder="'Select Company'"
                                         :preserve-search="false"
                                         label="name"
                                         track-by="id"
                                         @input="search"
                        >
                          <template slot="tag" slot-scope="props">
                            <div class="multiselect__tag">
                              <span>{{ props.option.name }}</span>
                              <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                            </div>
                          </template>
                        </key-multiselect>
                      </div>
                    </div>
                    <div class="col-12" v-if="carriers && carriers.length">
                      <div class="select-wrap">
                        <label>Carriers</label>
                        <key-multiselect v-model="filters.carrier"
                                         :options="carriers"
                                         :multiple="true"
                                         :clear-on-select="false"
                                         :close-on-select="false"
                                         :hide-selected="true"
                                         :id="'carrier-select'"
                                         :placeholder="'Select Carriers'"
                                         :preserve-search="false"
                                         label="name"
                                         track-by="id"
                                         @input="search"
                        >
                          <template slot="tag" slot-scope="props">
                            <div class="multiselect__tag">
                              <span>{{ props.option.name }}</span>
                              <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                            </div>
                          </template>
                        </key-multiselect>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="select-wrap">
                        <label>Payment gateway</label>
                        <simple-select v-model="filters.gateway"
                                       :options="paymentGateways"
                                       :input-id="'payment-gateway-select'"
                                       placeholder="Select Gateway"
                                       @input="search"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!(!filters.company.length && !filters.carrier.length && !filters.gateway)"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import Modal from '../Modal';
import Pagination from '../Pagination';

export default {
  name: 'PaymentGateways',
  components: {
    ErrorField,
    Modal,
    Pagination,
  },
  data: () => ({
    value: '',
    paymentProfilesAuthorize: null,
    paymentProfilesStripe: null,
    metaAuthorize: null,
    metaStripe: null,
    paymentGateways: [],
    editProfile: {},
    paymentProfile: {
      name: '',
      payment_gateway_id: '',
      payment_gateway_name: '',
      companies: [],
      credentials: {},
    },
    filters: {
      company: [],
      gateway: '',
      carrier: [],
    },
    showCreateModal: false,
    showEditModal: false,
    loadingButton: false,
    buttonDisabled: false,
    showFilters: false,
    q: '',
    timer: null,
    page: 1,
    pageAuthorize: '',
    pageStripe: '',
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
      carriers: state => state.carriers.carriers.data,
      filtersLoaded: state => state.guard.filtersLoaded,
    }),
  },
  mounted() {
    this.getPaymentGateways();
    this.loadPaymentProfiles();
    if (Object.keys(this.$route.query).length !== 0) {
      this.setFilters(this.$route.query);
    }
    this.filter();
  },
  methods: {
    setFilters(query) {
      this.filters = Object.assign(
        {
          carrier: query.default_carrier_id
            ? query.default_carrier_id.split(',').map(i => Number(i))
            : [],
          company: query.company_id ? query.company_id.split(',').map(i => Number(i)) : [],
          gateway: query.payment_gateway_id ? parseInt(query.payment_gateway_id, 10) : '',
        },
        {},
      );
      this.q = query.q.toString();
      this.page = query.page;
    },
    paymentCompanies(array) {
      return array
        .map((el, index) => {
          if ((index + 1) % 3 === 0) {
            return `${el.name}, <br />`;
          }
          if (index + 1 === array.length) {
            return el.name;
          }
          return `${el.name},`;
        })
        .join(' ');
    },
    loadPaymentProfiles() {
      this.getPaymentProfiles(1);
      this.getPaymentProfiles(2);
    },
    getPaymentProfiles(gatewayId) {
      let page;
      if (gatewayId === 1) {
        page = this.pageStripe;
      }
      if (gatewayId === 2) {
        page = this.pageAuthorize;
      }
      axios
        .get(`/companies/payment-profiles?payment_gateway_id=${gatewayId}&page=${page}`)
        .then(res => {
          if (gatewayId === 1) {
            this.paymentProfilesStripe = res.data.data;
            this.metaStripe = res.data.meta;
          }
          if (gatewayId === 2) {
            this.paymentProfilesAuthorize = res.data.data;
            this.metaAuthorize = res.data.meta;
          }
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getPaymentGateways() {
      axios
        .get('/values/payment-gateways')
        .then(res => {
          this.paymentGateways = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    save() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .post(`/companies/payment-profiles`, {
          payment_gateway_id: this.paymentProfile.payment_gateway_id,
          name: this.paymentProfile.name,
          company_ids: this.paymentProfile.companies.map(el => {
            return el.id;
          }),
          credentials: this.paymentProfile.credentials,
        })
        .then(() => {
          this.loadPaymentProfiles();
          toastr.success('Payment gateway saved');
          this.showCreateModal = false;
          this.errors.clear();
          this.paymentProfile = {
            name: '',
            payment_gateway_id: '',
            company_ids: {},
            credentials: {},
          };
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    edit() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .put(`/companies/payment-profiles/${this.editProfile.id}`, {
          payment_gateway_id: this.editProfile.payment_gateway_id,
          name: this.editProfile.name,
          company_ids: this.editProfile.companies.map(el => {
            return el.id;
          }),
          credentials: this.editProfile.credentials,
        })
        .then(() => {
          this.loadPaymentProfiles();
          toastr.success('Payment gateway saved');
          this.closeModal();
          this.editProfile = {};
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    openEditModal(paymentProfile) {
      this.showEditModal = true;
      this.editProfile = paymentProfile;
    },
    deleteProfile() {
      axios
        .delete(`/companies/payment-profiles/${this.editProfile.id}`)
        .then(() => {
          this.loadPaymentProfiles();
          this.closeModal();
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    closeModal() {
      this.showCreateModal = false;
      this.showEditModal = false;
      this.errors.clear();
      this.editProfile = {};
    },
    changePageAuthorize(pageNum) {
      this.pageAuthorize = pageNum;
      this.getPaymentProfiles(2);
    },
    changePageStripe(pageNum) {
      this.pageStripe = pageNum;
      this.getPaymentProfiles(1);
    },
    paymentProfilesFiltered(gatewayId) {
      let page = 1;
      if (gatewayId === 1) {
        page = this.pageStripe;
      }
      if (gatewayId === 2) {
        page = this.pageAuthorize;
      }
      const query = `page=${page}&default_carrier_id=${this.filters.carrier}&company_id=${
        this.filters.company
      }&payment_gateway_id=${this.filters.gateway ? this.filters.gateway : ''}&q=${this.q}`;
      axios
        .get(
          `/companies/payment-profiles?page=${page}&default_carrier_id=${
            this.filters.carrier
          }&payment_gateway_id=${
            this.filters.gateway ? this.filters.gateway : gatewayId
          }&company_id=${this.filters.company}&q=${encodeURIComponent(this.q)}`,
        )
        .then(res => {
          if (gatewayId === 1 && !this.filters.gateway) {
            this.paymentProfilesStripe = res.data.data;
            this.metaStripe = res.data.meta;
          } else if (this.filters.gateway === 1) {
            this.paymentProfilesAuthorize = [];
            this.paymentProfilesStripe = res.data.data;
            this.metaStripe = res.data.meta;
          }
          if (gatewayId === 2 && !this.filters.gateway) {
            this.paymentProfilesAuthorize = res.data.data;
            this.metaAuthorize = res.data.meta;
          } else if (this.filters.gateway === 2) {
            this.paymentProfilesStripe = [];
            this.paymentProfilesAuthorize = res.data.data;
            this.metaStripe = res.data.meta;
          }
        })
        .catch(err => this.errors.record(err.response.data.error));
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/settings/payment-gateways?${query}`);
      } else {
        this.$router.push(`/settings/payment-gateways`);
      }
    },
    filter() {
      this.paymentProfilesFiltered(1);
      this.paymentProfilesFiltered(2);
    },
    search() {
      this.page = 1;
      this.filter();
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          company: [],
          carrier: [],
          gateway: '',
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      this.search();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsPaymentGateways.vue